module.exports = __webpack_public_path__ + "static/media/[象棋]@2x.c85a54fa.png";